var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRestaurantFilled = function SvgRestaurantFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05249 4.35352V11.1749C6.05249 14.0477 8.38137 16.3766 11.2542 16.3766V16.3766C14.127 16.3766 16.4559 14.0477 16.4559 11.1749V4.35352",
    stroke: "#2698EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.344,
    y: 3.41992,
    width: 1.82054,
    height: 28,
    rx: 0.910268,
    fill: "#2698EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8176 20.9393H26.0524V4.35352C23.1613 4.35352 20.8176 6.69722 20.8176 9.58833V20.9393Z",
    fill: "#F1F8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0524 20.9393H20.8176V9.58833C20.8176 6.69722 23.1613 4.35352 26.0524 4.35352V4.35352V30.5596",
    stroke: "#2698EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRestaurantFilled;